export enum AttachmentType {
  Image = "image",
  Video = "video",
  PDF = "pdf",
}
